var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98438 0.00012207C13.4004 0.00012207 16.9844 3.59212 16.9844 8.00012L16.9813 8.22393C16.8626 12.5366 13.3255 16.0001 8.98438 16.0001C4.57637 16.0001 0.984375 12.4161 0.984375 8.00012C0.984375 3.59212 4.57637 0.00012207 8.98438 0.00012207ZM5.7844 9.58414C6.0244 9.81614 6.4004 9.81614 6.6324 9.57614L8.9844 7.21614L11.3364 9.57614C11.5684 9.81614 11.9524 9.81614 12.1844 9.58414C12.4244 9.34414 12.4244 8.96814 12.1844 8.73614L9.4084 5.94414C9.2964 5.83214 9.1444 5.76814 8.9844 5.76814C8.8244 5.76814 8.6724 5.83214 8.5604 5.94414L5.7844 8.73614C5.6644 8.84814 5.6084 9.00014 5.6084 9.15214C5.6084 9.31214 5.6644 9.46414 5.7844 9.58414Z",
    fill: "#88A5CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp2);
export default __webpack_public_path__ + "static/media/arrow-up2.f6df9518f7b0d24efbcab49582ef856b.svg";
export { ForwardRef as ReactComponent };